import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Browsers preserve scroll position across client-side route changes, which
// leaves the customer stranded mid-page on whatever they navigate to next.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
